var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGraph3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 696,
    height: 344,
    viewBox: "0 0 696 344",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_23018",
    "data-name": "Raggruppa 23018",
    transform: "translate(-1150 -736)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_11479",
    "data-name": "Rettangolo 11479",
    width: 696,
    height: 344,
    rx: 8,
    transform: "translate(1150 736)",
    fill: "#e5e5e5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-camera",
    "data-name": "Icon feather-camera",
    transform: "translate(1470.5 881.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_32928",
    "data-name": "Tracciato 32928",
    d: "M54.5,43.045a4.818,4.818,0,0,1-4.818,4.818H6.318A4.818,4.818,0,0,1,1.5,43.045v-26.5a4.818,4.818,0,0,1,4.818-4.818h9.636L20.773,4.5H35.227l4.818,7.227h9.636A4.818,4.818,0,0,1,54.5,16.545Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#b8b8b8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_32929",
    "data-name": "Tracciato 32929",
    d: "M31.273,23.136A9.636,9.636,0,1,1,21.636,13.5,9.636,9.636,0,0,1,31.273,23.136Z",
    transform: "translate(6.364 5.455)",
    fill: "none",
    stroke: "#b8b8b8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraph3);
export default __webpack_public_path__ + "static/media/graph3.12213a401e38efd1260fb1b4a8bc11c8.svg";
export { ForwardRef as ReactComponent };